import React,{ useRef }from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';
import './NavbarN.css'
import emailjs from '@emailjs/browser';
// import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// import Resume from "../../../public/resume/Resume.pdf"
// import { useNavigate } from "react-router-dom";




const NavbarN = () => {

  const form = useRef();
  // const[done, setDone] = useState(false);

  // const Navigate = useNavigate();

  const sendEmail = (e) => {
    e.preventDefault();
  
    emailjs.sendForm('service_8hno6t2', 'template_nja8ja8', form.current, '4CLFhEdKE4DKIvABU')
      .then((result) => {
          console.log(result.text);
          // setDone(true);
          // this.form.value="";
          form.current.reset();
        toast("Thank You for Contacting me");

      // Navigate("/");
      }, (error) => {
          console.log(error.text);
      });
  };


  // function downloadResume() {
  //   // Replace 'resume.pdf' with the name of your PDF file
  //   const pdfName = 'Resume.pdf';
  
  //   // Replace 'path/to/resume.pdf' with the path to your PDF file
  //   const pdfPath = './Resume.pdf';
  
  //   // Use fetch to get the PDF file as a blob
  //   fetch(pdfPath)
  //     .then(response => response.blob())
  //     .then(blob => {
  //       // Create a URL for the PDF blob
  //       const url = window.URL.createObjectURL(new Blob([blob]));
  
  //       // Create a link element and set its href and download attributes
  //       const link = document.createElement('a');
  //       link.href = url;
  //       link.setAttribute('download', pdfName);
  
  //       // Click the link element to trigger the download
  //       link.click();
  //     });
  // }
  


//   const onButtonClick = () => {
//     // using Java Script method to get PDF file
//     fetch('VivekResume.pdf').then(response => {
//         response.blob().then(blob => {
//             // Creating new object of PDF file
//             const fileURL = window.URL.createObjectURL(blob);
//             // Setting various property values
//             let alink = document.createElement('a');
//             alink.href = fileURL;
//             alink.download = 'VivekResume.pdf';
//             alink.click();
//         })
//     }).catch((error) => console.log(error));
// }
  return (
    <div>
      <Navbar bg="light" expand="lg" >
      <Container>
        <Navbar.Brand href="#home"><b>PORTFO<span class="sub">LIO</span></b></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#Home"><strong style={{fontWeight:"bold"}}>Home</strong></Nav.Link>
            <Nav.Link href="#About"><strong style={{fontWeight:"bold"}}>About</strong></Nav.Link>
            <Nav.Link href="#Projects"><strong style={{fontWeight:"bold"}}>Projects</strong></Nav.Link>
            <Nav.Link href="#Contact"><strong style={{fontWeight:"bold"}}>Contact</strong></Nav.Link>
            <NavDropdown title="MyProjects" id="basic-nav-dropdown" style={{fontWeight:"bold"}}>
              <NavDropdown.Item href="https://stack-overflow.cyclic.app/">StackOverflow-Clone</NavDropdown.Item>
              <NavDropdown.Item href="https://instagram-clone-ntpx.onrender.com/">
              Instagram-Clone
              </NavDropdown.Item>
              <NavDropdown.Item href="https://chat-bot-ashen.vercel.app/">ChatBot-App</NavDropdown.Item>
              <NavDropdown.Item href="https://todolist-app.cyclic.app/">Todolist-app</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    <div id="Home">
              <h1 style={{fontSize:"2.5rem",margin:"10px"}}>Hi, I am Vivek <strong className="n-color">Dhole</strong></h1>
              <h2 class="animate__animated animate__pulse animate__infinite infinite">I am a <strong className="n-color">Web Developer</strong></h2>
              <a href="#Contact" class="btn btn-danger bt-1" style={{margin:"15px"}}>Contact me</a>
          </div>
{/* About Section  */}
          <section id="About">
          <h2 class="animate__animated animate__pulse animate__infinite infinite h h1"><strong>ABOUT ME</strong></h2>
          <div class="container">
              <div class="row row-item">
                  <div class="col-sm-6 cols-1">
                   <h5 class="p1">Name:<strong class="sub">Vivek Dhole</strong></h5>
                   {/* <h5 class="p1">Dob:<strong strong class="sub">5 Aug 1999</strong></h5> */}
                   <h5 class="p1">Gmail:<strong strong class="sub">vivekdhole2019@gmail.com</strong></h5>
                   <h5 class="p1">Mob:<strong strong class="sub">9168732004</strong></h5>
                   <h5 class="p1">City:<strong class="sub">Yavatmal,Maharastra<span className='c-name'>,India</span></strong></h5>
                   {/* <a href="https://drive.google.com/file/d/1cw3PclrI-WxFWokQVuG1fNj7PbIZQwO7/view?usp=share_link" attributes-list download="newfilename"> */}
                    {/* <button type='button' className='button s-button' onClick={onButtonClick}>Download CV</button> */}
                    <button type='button' className='button s-button'><a style={{color: "white"}} href="https://drive.google.com/file/d/1xtxu-4uG43yzvU-fhoqC7wViqef_zu5H/view?usp=drive_link">Download CV</a></button>
                  {/* </a> */}
                  </div>
                  <div class="col-sm-6 cols-2 s-div">
                    <span>HTML</span>
                    <div class="progress">
                        <div class="progress-bar pro">90%</div>
                    </div>
                    <span>CSS</span>
                    <div class="progress">
                        <div class="progress-bar pro-1">90%</div>
                    </div>
                    <span>JAVASCRIPT</span>
                    <div class="progress">
                        <div class="progress-bar pro-2">80%</div>
                    </div>
                    <span>JAVA</span>
                    <div class="progress">
                        <div class="progress-bar pro-3">70%</div>
                    </div>
                    <span>React</span>
                    <div class="progress">
                        <div class="progress-bar pro-4">80%</div>
                    </div>
                    <span>Angular</span>
                    <div class="progress">
                        <div class="progress-bar pro-5">60%</div>
                    </div>
                    <span>MySQL</span>
                    <div class="progress">
                        <div class="progress-bar pro-6">80%</div>
                    </div>
                    <span>Oracle</span>
                    <div class="progress">
                        <div class="progress-bar pro-6">90%</div>
                    </div>
                    <span>MongoDB</span>
                    <div class="progress">
                        <div class="progress-bar pro-7">60%</div>
                    </div>
                   
                </div>
              </div>
          </div>
      </section>

{/* Contact-section  */}
<section id="Projects">
  <div className="container">
<h2 class="animate__animated animate__pulse animate__infinite infinite h h1"><strong>MY PROJECTS</strong></h2>
<div>
<Carousel>
      <Carousel.Item>
        <a href="https://stack-overflow.cyclic.app/">
        <img
          className="d-block "
          src={require("../../img/stackoverflow.png")}
          alt="First slide"
        />
        </a>
      </Carousel.Item>
      <Carousel.Item>
        <a href="https://instagram-clone-ntpx.onrender.com/">
        <img
          className="d-block "
          src={require("../../img/Instagram-clone.png")}
          alt="Second slide"
        />
        </a>
      </Carousel.Item>
      <Carousel.Item>
        <a href="https://chat-bot-ashen.vercel.app/">

        <img
          className="d-block "
          src={require("../../img/ChatBot.png")}
          alt="Third slide"
        />
        </a>
      </Carousel.Item>
      <Carousel.Item>
        <a href="https://technews-website.netlify.app/">

        <img
          className="d-block "
          src={require("../../img/TechNews.png")}
          alt="Third slide"
        />
        </a>
      </Carousel.Item>
      <Carousel.Item>
        <a href="https://youtube-app-lite.netlify.app/">

        <img
          className="d-block "
          src={require("../../img/youtube_lite.png")}
          alt="Fourth slide"
        />
        </a>
      </Carousel.Item>
      <Carousel.Item>
        <a href="https://todolist-app.cyclic.app/">

        <img
          className="d-block "
      src={require("../../img/Todolist.png")}
          alt="Fifth slide"
        />
        </a>
        {/* <Carousel.Caption>
          <h3>Fourth slide label</h3>
          <p>
            Praesent commodo cursus magna, vel scelerisque nisl consectetur.
          </p>
        </Carousel.Caption> */}
      </Carousel.Item>
    </Carousel>
    </div>
    </div>
</section>

{/* Contact Section */}
<section id="Contact">
    <div class="container">
      <h2 class="animate__animated animate__pulse animate__infinite infinite h h1"><strong>CONTACT ME</strong></h2>
      <div class="row">
        <div class="col-sm-6">
          <form ref={form} onSubmit={sendEmail}>
            <div class="form-control ne">
              <label for="user">Name</label>
              <input type="text" name='from_name' class="form-control" placeholder="Enter Your Name" required />
              <label for="email">Email Id</label>
              <input type="email" name="user_email" class="form-control" placeholder="Enter Your Email" required/>
              <label for="comment">Comment</label>
              <textarea class="form-control" name="message" rows="5" cols="80" placeholder="Message"></textarea>
              <button type="submit" name="submit" class="btn btn-secondary bt">Submit</button>
            {/* <span style={{color:"white"}}>{done && "Thanks for contacting me!"}</span> */}
            </div>
            <ToastContainer 
              theme="dark"
              />
          </form>
        </div>
        <div class="col-sm-6 icon">
          <h3 class="animate__animated animate__flash animate__infinite infinite h"><strong> follow me </strong></h3>
          <a href="https://api.whatsapp.com/send?phone=+919168732004&text=hello"><i class="fab fa-whatsapp fi"></i></a>
          <a href="https://instagram.com/vivek_dhole?utm_medium=copy_link"><i class="fab fa-instagram fi"></i></a>
          <a href="https://www.facebook.com/vivek.dhole.1"><i class="fab fa-facebook-f fi"></i></a>
          <a href="https://github.com/Vicky9168"><i class="fab fa-github fi"></i></a>
          <a href="https://linkedin.com/in/vivek-dhole-74a001226"><i class="fab fa-linkedin-in fi"></i></a>
        </div>
      </div>
    </div>
  </section>

  
  {/* <!-- Footer Section--> */}
  <footer>
      <div class="container-fluid">
        <h5>
          <span>Created By <a href="https://vivekdhole01.netlify.app/">Vivek</a> | </span>Copyright © All rights reserved</h5>
      </div>
  </footer>
    </div>
  )
}
export default NavbarN
